const locale = {
    placeholder: 'Velja tíma',
    rangePlaceholder: ['Upphafstími', 'Loktími'],
};
export default locale;
